module.exports = {
  // SERVER_URL: "http://192.168.30.131:5100/api/"//dev ÷
  // SERVER_URL: "http://192.168.30.122:5200/api/"//IP
  // SERVER_URL: "https://survey-api.laodeveloper.com/api/" // dev
  SERVER_URL: "https://api.phongsavanhgroup.com/api/" // prod
};
